import moment from "moment";
import React from "react";

interface Props {
  euVatNumber: server.dto.EuVatNumber
  displayDot?: boolean
}

const VatNumberDetailsCard = (props: Props) => {
  const { euVatNumber } = props;

  let { displayDot } = props;

  if (displayDot === undefined) {
    displayDot = true;
  }

  if (!euVatNumber.isEuMember) {
    return <div>{euVatNumber.number ?? RESX.ViesValidationLabels.NoData}</div>;
  }

  if (euVatNumber.number == null) {
    return <div className="flex">
      {displayDot && <div className="margin-right-small">
        <i className="icon-circle red" />
      </div>}
      <div>
        {RESX.ViesValidationLabels.NoData}
      </div>
    </div>;
  }

  if (euVatNumber.viesValidationOutcome === "formattingError") {
    return <div className="flex">
      {displayDot && <div className="margin-right-small">
        <i className="icon-circle red" />
      </div>}
      <div>
        <div>{euVatNumber.number}</div>
        <div className="s1_small red">{RESX.ViesValidationLabels.FormattingError}</div>
      </div>
    </div>;
  }

  return <div className="flex">
    {displayDot && <div className="margin-right-small">
      <i className="icon-circle" style={{ color: euVatNumber.validationHexColor }} />
    </div>}
    <div>
      <div>{euVatNumber.number}</div>
      <div className="s1_small">{euVatNumber.validationOutcomeText}</div>
      {(euVatNumber.viesValidationUtc != null) && <div className="text-sublabel">{RESX.GeneralLabels.LastCheck}: {moment.utc(euVatNumber.viesValidationUtc).fromNow()}</div>}
    </div>
  </div>;
};

export default VatNumberDetailsCard;